import { Injectable, Injector, inject } from '@angular/core';
import { map } from 'rxjs/operators';
import { AuthService, UserService } from '../services';
import { CanActivateFn, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { nrAction } from '../helpers/newrelic.helper';
import { awaitUserLookup } from './await-user-lookup';

@Injectable({
  providedIn: 'root'
})
export class CxAdminGuardCanActivate {
  private readonly injector = inject(Injector);

  constructor(private authService: AuthService, private userService: UserService, private router: Router) {
  }

  public canActivate(): Observable<boolean> {
    if (this.authService.getAuthToken() === '') {
      nrAction('guard_blocked', { guard: 'CxAdminGuard', reason: 'no_token' });
      this.authService.login();
      return of(false)
    }

    return awaitUserLookup(this.userService, this.injector).pipe(
      map(({ user, error }) => {
        const isCxAdmin = user?.roles?.includes('cx_admin');
        if (isCxAdmin) {
          return true;
        }
        nrAction('guard_blocked', { guard: 'CxAdminGuard', reason: error ? 'lookup_failed' : 'not_cx_admin' });
        this.router.navigate(['/']);
        return false;
      }));
  }
}

export const CxAdminGuard: CanActivateFn = () => {
  return inject(CxAdminGuardCanActivate).canActivate();
};
